import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const mappingProjectSliceSelector = (state: RootState) => state.mappingProject;

export const selectedMappingProjectSelector = createSelector(
  mappingProjectSliceSelector,
  (state) => state.mappingProject,
);
